import { render, staticRenderFns } from "./panel_type.vue?vue&type=template&id=6bfc5b2e&"
import script from "./panel_type.vue?vue&type=script&lang=js&"
export * from "./panel_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports